/*jslint browser: true*/
/*global $, jQuery*/

jQuery(function ($) {
  "use strict";

  // Typeahead is an old package so we need to require the files directly.
  require("typeahead.js/dist/typeahead.jquery.js");
  const Bloodhound = require("typeahead.js/dist/bloodhound.min.js");

  // Helper function to retrieve the value of a query parameter from the
  // current url.
  $.QueryString = (function (a) {
    if (a == "") return {};
    var b = {};
    for (var i = 0; i < a.length; ++i) {
      var p = a[i].split("=");
      if (p.length != 2) continue;
      b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
    }
    return b;
  })(window.location.search.substr(1).split("&"));

  // ID of the subsite being viewed
  var subsiteID = $("body").data("subsite-id");

  // Determine whether to search just the current site or all sites.
  var searchAll = false;
  if (subsiteID == 0 || $.QueryString["GlobalSearch"]) {
    searchAll = true;
  }

  // Apply typeahead to search elements, but without the data source.
  var autocomplete = false;
  var searchelements = [
    "#Form_SearchPageForm_Search",
    "#SearchForm_SearchForm_Search",
  ];
  $.each(searchelements, function (i, val) {
    $(val).typeahead({
      minLength: 3,
      hint: false,
    });
  });

  // When a search element is focused, apply typeahead with the data source.
  $.each(searchelements, function (index, value) {
    $(this).focus(function () {
      if (autocomplete == false) {
        // Initializa Bloodhound to retrieve search suggestions.
        var titles = new Bloodhound({
          datumTokenizer: function (datum) {
            return Bloodhound.tokenizers.whitespace(datum.term);
          },
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          prefetch: {
            url: "/assets/json/search_autocomplete_data.js",
            // Store in local storage for 1 hour.
            ttl: 3600000,
            filter: function (response) {
              return $.map(response, function (page) {
                return {
                  term: page.t,
                  subsite: page.s,
                };
              });
            },
          },
          // Sort suggestions alphabetically.
          sorter: function (a, b) {
            if (a.term > b.term) {
              return 1;
            } else {
              return 0;
            }
          },
          // Ensures only unique suggestions are returned.
          identify: function (a) {
            return a.term;
          },
        });

        // Filter the titles, limiting to the current subsite if required.
        var selected = [];
        var filter = function (suggestions) {
          return $.grep(suggestions, function (suggestion) {
            if (
              suggestion.subsite == subsiteID ||
              searchAll ||
              suggestion.subsite == 0
            ) {
              return $.inArray(suggestion.val, selected) === -1;
            }
          });
        };

        // Apply typeahead to search elements.
        $.each(searchelements, function (i, val) {
          $(val).typeahead(
            {
              minLength: 3,
              hint: false,
            },
            {
              name: "engine",
              displayKey: "term",
              source: function (query, cb) {
                titles.search(query, function (suggestions) {
                  cb(filter(suggestions));
                });
              },
            }
          );
        });

        autocomplete = true;
        // Applying typeahead makes the input lose focus, so
        // re focus the element.
        var input = "#" + this.id;
        setTimeout(function () {
          $(input).trigger("focus");
        }, 1);
      }
    });
  });
});
